<template>
  <div>
    <Bar :data="chartData" :options="chartOptions" />
  </div>
</template>

<script>
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'vue-chartjs';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

export default {
  components: {
    Bar,
  },
  props: {
    dados: {
      type: Array,
      required: true,
      default: () => [],
    },
    titulo: {
      type: String,
      default: 'Velocity Chart',
    },
  },
  data() {
    return {
      chartData: {
        labels: this.dados.map((item) => item.tituloMilestone),
        /* eslint-disable */
        datasets: [
          {
            label: 'Compromisso (Total Story Points)',
            data: this.dados.map((item) => ({
              x: item.tituloMilestone,
              y: item.totalStoryPoints,
              dt_inicio: item.dt_inicio,
              dt_fim: item.dt_fim,
            })),
            backgroundColor: '#282e70',
          },
          {
            label: 'Completo (Story Points Completados)',
            data: this.dados.map((item) => ({
              x: item.tituloMilestone,
              y: item.completedStoryPoints,
              dt_inicio: item.dt_inicio,
              dt_fim: item.dt_fim,
            })),
            backgroundColor: '#00fc7a',
          },
          /* eslint-enabled */
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            title: {
              display: true,
              text: 'Sprints',
              font: {
                weight: 'bold',
              },
            },
          },
          y: {
            title: {
              display: true,
              text: 'Story Points',
              font: {
                weight: 'bold',
              },
            },
            ticks: {
              precision: 0,
            },
          },
        },
        plugins: {
          legend: {
            display: true,
            position: 'top',
          },
          tooltip: {
            callbacks: {
              label: (context) => {
                console.log(context);
                console.log(this.dados);
                const datasetLabel = context.dataset.label;
                const storyPoints = context.raw;
                const index = context.dataIndex;
                console.log(index);
                const sprint = context.chart.data.labels[index];
                const dtInicio = this.formatDate(this.dados[index].dt_inicio);
                const dtFim = this.formatDate(this.dados[index].dt_fim);

                return [
                  `${datasetLabel}: ${storyPoints} Story Points`,
                  `Sprint: ${sprint}`,
                  `Início: ${dtInicio}`,
                  `Fim: ${dtFim}`,
                ];
              },
            },
          },
        },
      },
    };
  },
  watch: {
    dados: {
      handler(newData) {
        this.chartData.labels = newData.map((item) => item.tituloMilestone);
        this.chartData.datasets[0].data = newData.map(
          (item) => item.totalStoryPoints
        );
        this.chartData.datasets[1].data = newData.map(
          (item) => item.completedStoryPoints
        );
      },
      immediate: true,
    },
  },
  methods: {
    formatDate(date) {
      return date.split('-').join('/');
    },
  },
};
</script>

<style scoped>
.chart-container {
  width: 100%;
  height: 400px;
}
</style>
